__turbopack_context__.v({
  "card": "WhyGrowthSection-module__F_YUVW__card",
  "cardTitle": "WhyGrowthSection-module__F_YUVW__cardTitle",
  "iconCircle": "WhyGrowthSection-module__F_YUVW__iconCircle",
  "sectionSubtitle": "WhyGrowthSection-module__F_YUVW__sectionSubtitle",
  "sectionTitle": "WhyGrowthSection-module__F_YUVW__sectionTitle",
  "whyChooseSection": "WhyGrowthSection-module__F_YUVW__whyChooseSection",
});
